/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tracking_Back_To_LiveInputs */

const vi_tracking_back_to_live = /** @type {(inputs: Tracking_Back_To_LiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về vị trí hiện tại`)
};

/**

* @param {Tracking_Back_To_LiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tracking_back_to_live = /** @type {((inputs?: Tracking_Back_To_LiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tracking_Back_To_LiveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tracking_back_to_live(inputs)
});